export class EventDispatcher {
    constructor() {
        this.listeners = new Set();
    }
    subscribe(listener) {
        this.listeners.add(listener);
        return () => {
            this.listeners.delete(listener);
        };
    }
    notify(data) {
        this.listeners.forEach((listener) => {
            try {
                listener(data);
            }
            catch (error) {
                console.error('Error in event listener:', error);
            }
        });
    }
    clear() {
        this.listeners.clear();
    }
}
